import React, { useRef } from 'react';
import Marquee from '../Marquee';
import RevealText from '../RevealText';
import { BG_GLOW } from '../../mock';
import { motion, useScroll } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export default function WhoIAm() {
  const containerRef = useRef(null);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });

  return (
    <>
      <div className="bg-[var(--bg)] pt-20 md:pt-28 pb-10">
        <Marquee
          items={['QUEM SOU EU!', 'QUEM SOU EU!', 'QUEM SOU EU!', 'QUEM SOU EU!', 'QUEM SOU EU!']}
          speed={8}
          className="border-y border-[var(--border)]"
        />
      </div>

      <section ref={containerRef} id="about" className="relative bg-[var(--bg)]" style={{ height: '250vh', marginBottom: '-10vh' }}>
        <div className="sticky top-[110px] md:top-28 h-[calc(100vh-110px)] md:h-[calc(100vh-112px)] w-full flex items-center">
          <div className="relative w-full px-6 md:px-10 max-w-6xl mx-auto pb-20 md:pb-32">
            {/* Decorative blurred glow background */}
            <div
              className="absolute inset-0 -z-0 opacity-40 pointer-events-none scale-150 optimized-glow"
              style={{
                '--glow-image': `url(${BG_GLOW})`,
                filter: 'blur(80px) saturate(150%)',
                maskImage: 'radial-gradient(circle at center, black 30%, transparent 70%)',
                WebkitMaskImage: 'radial-gradient(circle at center, black 30%, transparent 70%)',
              }}
            />

            <div className="relative z-10">
              <RevealText
                scrollProgress={scrollYProgress}
                text={
                  'Sou Maycon Robert, designer gráfico e web com mais de 18 anos de experiência, atuando no encontro entre design, animação e desenvolvimento web. Minha ampla experiência me permite abordar desafios de design sob múltiplas perspectivas.'
                }
                className="font-display text-2xl md:text-4xl lg:text-5xl uppercase tracking-[-0.01em] leading-[1.2] text-white"
              />

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.8 }}
                className="mt-14 flex justify-start md:justify-center"
              >
                <a
                  href="https://www.linkedin.com/in/mayconrobert/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-3 px-7 py-4 rounded-full bg-gradient-to-r from-[var(--accent)] to-[var(--accent-secondary)] text-white font-semibold tracking-[0.2em] text-xs md:text-sm hover:shadow-[0_10px_40px_rgba(255,90,31,0.45)] transition-shadow"
                >
                  SAIBA MAIS SOBRE MIM
                  <ArrowUpRight size={16} strokeWidth={2.5} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
